<section appInView (inView)="startCountAnimation()" class="relative py-12">
  <app-content-container>
    <!-- Section Title / Subtitle -->
    <div class="flex justify-center text-center mb-12">
      <div class="max-w-[720px]">
        <h2 class="section-title">
          Transformando o mercado de
          <span class="angular-font-color">Frontend</span>
        </h2>
        <p class="section-description mt-6">
          Engenharia de software aplicada ao frontend moderno para formar
          profissionais que lideram arquitetura e entrega técnica.
        </p>
      </div>
    </div>

    <!-- Stat Cards Grid -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
      <!-- Card 1: Hours -->
      <div
        class="glass-card p-8 rounded-2xl border border-white/10 bg-[#161E2E]/60 backdrop-blur-xl relative overflow-hidden group hover:border-primary/40 transition-all duration-300 shadow-xl"
      >
        <div
          class="absolute -right-8 -bottom-8 w-32 h-32 bg-primary/10 rounded-full blur-2xl group-hover:bg-primary/20 transition-all"
        ></div>
        <div class="flex flex-col items-center text-center relative z-10">
          <div
            class="w-12 h-12 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center text-primary text-xl mb-4"
          >
            <i class="bi bi-clock-history"></i>
          </div>
          <span
            class="text-primary font-black text-4xl sm:text-5xl tracking-tight mb-2"
          >
            {{ hoursDisplay() }}
          </span>
          <span class="text-gray-300 font-medium text-base"
            >Horas de Conteúdo Prático</span
          >
        </div>
      </div>

      <!-- Card 2: Developers -->
      <div
        class="glass-card p-8 rounded-2xl border border-white/10 bg-[#161E2E]/60 backdrop-blur-xl relative overflow-hidden group hover:border-accent/40 transition-all duration-300 shadow-xl"
      >
        <div
          class="absolute -right-8 -bottom-8 w-32 h-32 bg-accent/10 rounded-full blur-2xl group-hover:bg-accent/20 transition-all"
        ></div>
        <div class="flex flex-col items-center text-center relative z-10">
          <div
            class="w-12 h-12 rounded-xl bg-accent/10 border border-accent/20 flex items-center justify-center text-accent text-xl mb-4 shadow-[0_0_15px_rgba(219,39,119,0.2)]"
          >
            <i class="bi bi-people"></i>
          </div>
          <span
            class="text-accent font-black text-4xl sm:text-5xl tracking-tight mb-2"
          >
            {{ devsDisplay() }}
          </span>
          <span class="text-gray-300 font-medium text-base"
            >Devs Alcançados</span
          >
        </div>
      </div>

      <!-- Card 3: Approval -->
      <div
        class="glass-card p-8 rounded-2xl border border-white/10 bg-[#161E2E]/60 backdrop-blur-xl relative overflow-hidden group hover:border-emerald-500/40 transition-all duration-300 shadow-xl"
      >
        <div
          class="absolute -right-8 -bottom-8 w-32 h-32 bg-emerald-500/10 rounded-full blur-2xl group-hover:bg-emerald-500/20 transition-all"
        ></div>
        <div class="flex flex-col items-center text-center relative z-10">
          <div
            class="w-12 h-12 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center text-emerald-400 text-xl mb-4"
          >
            <i class="bi bi-star"></i>
          </div>
          <span
            class="text-emerald-400 font-black text-4xl sm:text-5xl tracking-tight mb-2"
          >
            {{ approvalDisplay() }}
          </span>
          <span class="text-gray-300 font-medium text-base"
            >Pessoas Satisfeitas</span
          >
        </div>
      </div>
    </div>
  </app-content-container>
</section>
